import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useKeycloak } from '@react-keycloak/web'
import { useCallback, useState } from 'react'

import { useAppContext } from '@/hooks'
import { useDetailTabContext } from '@/pages/User/pages/Home/components/DetailTab'
import { hasAiAccess } from '@/utils/roleAccess'

import { useStructureRefresh } from '../hooks/useStructureRefresh'
import { StructureType } from '../types'
import { SqlImportModal } from './SqlImportModal'

interface SqlImportButtonProps {
	structureType: StructureType
}

export const SqlImportButton = ({ structureType }: SqlImportButtonProps) => {
	const { t } = useAppContext()
	const { keycloak } = useKeycloak()
	const hasAiFeatureAccess = hasAiAccess(keycloak.tokenParsed)
	const {
		state: { node },
	} = useDetailTabContext()

	const [importDialogOpen, setImportDialogOpen] = useState(false)
	const refreshStructure = useStructureRefresh()

	const handleImportSuccess = useCallback(async () => {
		await refreshStructure(node)
	}, [refreshStructure, node])

	if (!hasAiFeatureAccess) {
		return null
	}

	return (
		<>
			<MenuItem onClick={() => setImportDialogOpen(true)}>
				<ListItemIcon>
					<CloudUploadIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText>{t('IMPORT_SQL')}</ListItemText>
			</MenuItem>

			<SqlImportModal
				open={importDialogOpen}
				structureType={structureType}
				structureId={node.id}
				structureName={node.name}
				onClose={() => setImportDialogOpen(false)}
				onSuccess={handleImportSuccess}
			/>
		</>
	)
}
